import { Button } from "../../../components/Button";
import { FormGroup } from "../../../components/FormGroup";
import { FormLabel } from "../../../components/FormLabel";
import { FormActions } from "../../../components/FormActions";
import { InfoBox } from "../../../components/InfoBox";
import { API_BASE_URL } from "../../../constants/api";
import { IntegrationType } from "@KassaroAB/shared/types/enums/IntegrationType";
import { useTranslation } from "react-i18next";
import type { RestIntegration } from "@KassaroAB/shared/types/integrations/integration";

type RestIntegrationSpiris = Extract<
  RestIntegration,
  { type: IntegrationType.SPIRIS }
>;

interface SpirisFormProps {
  storeId: string;
  integration?: RestIntegrationSpiris;
  onCancel: () => void;
}

export const SpirisForm = ({
  storeId,
  integration,
  onCancel,
}: SpirisFormProps) => {
  const { t } = useTranslation();
  const oauthUrl = `${API_BASE_URL}/stores/${storeId}/bookkeeping/integration/${IntegrationType.SPIRIS}/oauth2`;

  const handleOAuthClick = () => {
    window.location.href = oauthUrl;
  };

  if (integration) {
    return (
      <>
        <FormGroup>
          <FormLabel>{t("spirisIntegration.type")}</FormLabel>
          <div style={{ padding: "8px 0" }}>
            {t("spirisIntegration.name")}
          </div>
        </FormGroup>
        <InfoBox variant="info">{t("spirisIntegration.managedOAuth")}</InfoBox>
        <FormActions>
          <Button type="button" $color="secondary" onClick={onCancel}>
            {t("common.close")}
          </Button>
        </FormActions>
      </>
    );
  }

  return (
    <>
      <FormGroup>
        <FormLabel>{t("spirisIntegration.oauthSetup")}</FormLabel>
        <InfoBox variant="info">{t("spirisIntegration.connectInfo")}</InfoBox>
      </FormGroup>
      <FormActions>
        <Button type="button" $color="secondary" onClick={onCancel}>
          {t("common.cancel")}
        </Button>
        <Button type="button" onClick={handleOAuthClick}>
          {t("spirisIntegration.connectButton")}
        </Button>
      </FormActions>
    </>
  );
};
